"use client";

import { useState } from "react";
import { useTaskContext } from "@/contexts/TaskContext";

const PJK = "'Plus Jakarta Sans', var(--font-plus-jakarta), sans-serif";

/**
 * Non-blocking banner rendered at the top of the chat canvas while
 * the user's Community-LLM consent is still pending. Choices persist
 * into TaskContext (localStorage-backed). Landing-page files untouched.
 */
export default function ConsentBanner() {
  const ctx = useTaskContext();
  const [expanded, setExpanded] = useState(false);

  if (ctx.trainingConsent !== "pending") return null;

  return (
    <div
      className="app-anim-fade-up"
      style={{
        width: "100%",
        maxWidth: 720,
        margin: "0 auto",
        background: "rgba(134,53,246,0.08)",
        border: "1px solid rgba(134,53,246,0.35)",
        borderRadius: 16,
        padding: "14px 16px",
        display: "flex",
        flexDirection: "column",
        gap: 10,
        fontFamily: PJK,
        color: "#F2F0ED",
      }}
    >
      <p style={{ margin: 0, fontWeight: 500, fontSize: 14, lineHeight: "20px" }}>
        Help improve BotWork AI — opt in to share{" "}
        <strong style={{ fontWeight: 700 }}>anonymised</strong> task data for
        model training. Personal information is stripped before anything leaves
        your session.
      </p>

      {expanded && (
        <div
          style={{
            fontSize: 12,
            lineHeight: "18px",
            color: "rgba(242,240,237,0.75)",
            borderTop: "1px solid rgba(255,255,255,0.08)",
            paddingTop: 10,
          }}
        >
          <p style={{ margin: "0 0 6px 0" }}>
            <strong>What we collect:</strong> task description, clarifying
            answers, agent result, your rating. No personal info, no API keys.
          </p>
          <p style={{ margin: "0 0 6px 0" }}>
            <strong>How it's used:</strong> training open-source AI models that
            anyone on the network can run. You can opt out anytime in Settings.
          </p>
        </div>
      )}

      <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
        <button
          onClick={() => ctx.setTrainingConsent("opted_in")}
          className="app-btn-primary"
          style={{
            background: "#8635F6",
            border: "none",
            borderRadius: 9999,
            padding: "8px 18px",
            color: "#F2F0ED",
            fontFamily: PJK,
            fontSize: 13,
            fontWeight: 700,
            cursor: "pointer",
          }}
        >
          Opt in
        </button>
        <button
          onClick={() => ctx.setTrainingConsent("opted_out")}
          className="app-text-link"
          style={{
            background: "none",
            border: "none",
            color: "#D5BAFF",
            fontFamily: PJK,
            fontSize: 13,
            fontWeight: 600,
            cursor: "pointer",
            padding: "8px 4px",
          }}
        >
          No thanks
        </button>
        <button
          onClick={() => setExpanded((e) => !e)}
          className="app-text-link"
          style={{
            marginLeft: "auto",
            background: "none",
            border: "none",
            color: "rgba(242,240,237,0.6)",
            fontFamily: PJK,
            fontSize: 12,
            fontWeight: 500,
            cursor: "pointer",
            padding: "8px 4px",
          }}
        >
          {expanded ? "Hide details" : "Learn more"}
        </button>
      </div>
    </div>
  );
}
